/**
 * User Selectors
 */

import { createSelector } from 'reselect';

export const getUserState = ({ user }: IStoreState) => user;

export const getViewerId = createSelector(getUserState, ({ viewerId }) => viewerId);
export const getStripeToken = createSelector(getUserState, ({ stripeToken }) => stripeToken);
export const isUserLoggedIn = createSelector(getUserState, ({ isLoggedIn }) => isLoggedIn);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/public/redux/selectors/user.ts